import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ValeoSvgIcon from '../svg/ValeoSvgIcon';

const Title = () => (
  <Stack direction="row" spacing={2} alignItems="center" mb={2}>
    <ValeoSvgIcon width={100} height={100} />
    <Typography color="secondary" fontWeight="bold" variant="h4">
      DAM Plugin
    </Typography>
  </Stack>
);

export default Title;
